import React, { useEffect, useState } from 'react';

import { showMessage } from '../../../../helpers/message';
import infracoes_api from '../../../../api/infracoes_api';

// Components
import FichaRoc from './FichaRoc';
import CartaoFicha from './CartaoFicha';
import RodapeEmissor from './RodapeEmissor';


export default function ItemFichaRoc({ hash, parametrizacaoHash, titulo, numeroInfracao, onReady }) {
    const [ficha, setFicha] = useState(null);

    useEffect(() => {
        infracoes_api.GetImpressaoItemDadosRoc(hash, parametrizacaoHash)
            .then(({ data }) => setFicha(data))
            // Sem aviso, a ficha some da impressão e o fiscal não percebe que faltou uma página.
            .catch(error => showMessage("Aviso", error?.message ?? "Não foi possível carregar a Ficha do Protocolo (Sistema de Cadastros).", "warning", null))
            .finally(onReady);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hash, parametrizacaoHash]);

    if (!ficha) return null;
    return (
        <CartaoFicha titulo={titulo}>
            <FichaRoc ficha={ficha} />
            <RodapeEmissor numeroInfracao={numeroInfracao} />
        </CartaoFicha>
    );
}
